import React from 'react'
import { graphql, Link } from 'gatsby'
import { Helmet } from 'react-helmet'
import { Jumbotron } from 'reactstrap'

import BreadcrumbNav from '../components/breadcrumb-nav'
import Layout from '../components/layout'
import {
  flattenFileNode,
  matterNameFromMatter,
  classeNameFromClasse,
  classeWikidataURIFromClasse,
} from '../helpers'

import 'katex/dist/katex.min.css'

export default exoPage

function exoPage({ data, location }) {
  const exo = flattenFileNode(data.markdownRemark)

  const title = `Exercices de ${classeNameFromClasse(
    exo.classe
  )} en ${matterNameFromMatter(exo.matter)}: ${exo.chapter}`

  const description = `Exercices de ${classeNameFromClasse(
    exo.classe
  )} en ${matterNameFromMatter(exo.matter)} intitulé: «${exo.chapter}»`

  return (
    <Layout location={location} data={data}>
      <Helmet title={`${title}`} htmlAttributes={{ class: `exo` }}>
        <script type="application/ld+json">{`
         {"@context": "http://schema.org/",
          "@type": "exercice",
          "name": "${exo.part} | ${exo.chapter}",
          "description": "${description}",
          "learningResourceType": [
            "lesson"    ],
          "provider": {
            "@type": "schema:EducationalOrganization",
            "name": "lyceum.fr"
          },
          "audience": {
            "@type": "EducationalAudience",
            "éducationRole": "student"
          },
          "educationalAlignment": {
            "@type": "AlignmentObject",
            "alignmentType": "educationalLevel",
            "educationalFramework": "French Grade Levels",
            "targetName": "${classeNameFromClasse(exo.classe)}",
            "@id": "${classeWikidataURIFromClasse(exo.classe)}"
          },
          "url": "${location.href}"
        }
    `}</script>
      </Helmet>
      <BreadcrumbNav node={exo} />
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <Link
            className="nav-link"
            to={`${location.pathname.substring(
              0,
              location.pathname.length - 4
            )}`}
          >
            Cours
          </Link>
        </li>
        <li className="nav-item">
          <a
            className="nav-link disabled active"
            aria-current="exercices"
            href="#"
          >
            Exercices
          </a>
        </li>
      </ul>
      <Jumbotron>
        <h1 className="display-3">Exercices</h1>
        <strong className="display-4">{`Chapitre ${exo.nChapter}: ${exo.chapter}`}</strong>
      </Jumbotron>
      <div dangerouslySetInnerHTML={{ __html: exo.html }} />
    </Layout>
  )
}

export const query = graphql`
  query MDExoQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      fields {
        classe
        chapter
        matter
        nChapter
        part
        nPart
        type
      }
    }
  }
`
